import {TabsReducer} from "../../../../common/tabs/tabs.reducer";
import {IDS} from "../adm-categorisation-action-id.constants";

export const admCatDocumentsTabs = {

    [IDS.app_administration_categorisation_documents]: Object.assign(TabsReducer(), {
        tabs: [
            {
                state: IDS.app_administration_categorisation_documents_grid,
                title: 'Documents',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_administration_categorisation_documents_details,
                title: 'Details',
                visible: false,
                disabled: false,
                loading: false
            },
        ]
    }),
}